import React, { useState, useEffect } from "react"
import {
    Paper,
    Grid2,
    TextField,
    Table,
    TableHead,
    TableBody,
    TableCell,
    FormControl,
    InputLabel,
    TableRow,
    Select,
    MenuItem,
    IconButton,
    Tooltip,
    Checkbox,
    FormControlLabel,
    Button,
    Switch,
    Box,
    Typography,
} from "@mui/material"

import { makeStyles } from "@mui/styles"

import { Formik, Form, Field } from "formik"
import ButtonWithSpinner from "../ButtonWithSpinner"
import ConfirmationModal from "../ConfirmationModal"
import { Edit as EditIcon } from "@mui/icons-material"

import { toast } from "react-toastify"
import usePlans from "../../hooks/usePlans"
import { fCurrency } from "../../utils/formatNumbers"
import api from "../../services/api"

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    mainPaper: {
        width: "100%",
        flex: 1,
        padding: theme.spacing(2),
    },
    fullWidth: {
        width: "100%",
    },
    tableContainer: {
        width: "100%",
        overflowX: "scroll",
        ...theme.scrollbarStyles,
    },
    textfield: {
        width: "100%",
    },
    textRight: {
        textAlign: "right",
    },
    row: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    control: {
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
    },
    buttonContainer: {
        textAlign: "right",
        padding: theme.spacing(1),
    },
}))

export function PlanManagerForm(props) {
    const { onSubmit, onDelete, onCancel, initialValue, loading } = props
    const classes = useStyles()

    const [record, setRecord] = useState({
        name: "",
        users: 0,
        connections: 0,
        queues: 0,
        value: 0,
        interval: 1,

        lytexId: "",

        dashboard: true,
        kanban: true,
        forms: true,
        products: true,
        leads: true,
        tags: true,
        prompt: true,
        quickMessages: true,
        schedules: true,
        queueIntegration: true,
        audios: true,
        automation: true,
        chats: true,
        campaigns: true,
    })

    const [isCustomPlan, setIsCustomPlan] = useState(false)

    useEffect(() => {
        setRecord(initialValue)
        setIsCustomPlan(initialValue?.isCustomPlan)
    }, [initialValue])

    const handleSubmit = async (data) => {
        onSubmit({
            ...data,
            isCustomPlan,
        })
    }

    return (
        <Formik
            enableReinitialize
            className={classes.fullWidth}
            initialValues={record}
            onSubmit={(values, { resetForm }) =>
                setTimeout(() => {
                    handleSubmit(values)
                    resetForm()
                }, 500)
            }
        >
            {({ values, setFieldValue }) => (
                <Form className={classes.fullWidth}>
                    <Grid2 spacing={2} justifyContent="flex-end" container>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Field
                                as={TextField}
                                label="Nome"
                                name="name"
                                variant="outlined"
                                className={classes.fullWidth}
                                margin="dense"
                            />
                        </Grid2>
                        {(record.lytexId || !record.id) && (
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                <Field
                                    as={TextField}
                                    label="Valor"
                                    name="value"
                                    variant="outlined"
                                    className={classes.fullWidth}
                                    margin="dense"
                                    type="number"
                                />
                                {!record.lytexId && (
                                    <Typography variant="caption">
                                        Para criar um plano gratuito basta
                                        deixar o valor em branco
                                    </Typography>
                                )}
                            </Grid2>
                        )}
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Field
                                as={TextField}
                                label="Usuários"
                                name="users"
                                variant="outlined"
                                className={classes.fullWidth}
                                margin="dense"
                                type="number"
                            />
                        </Grid2>
                        {/* {record.lytexId && (
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                <FormControl
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                >
                                    <InputLabel htmlFor="recorrencia-selection">
                                        Recorrência
                                    </InputLabel>
                                    <Field
                                        as={Select}
                                        label="Recorrência"
                                        labelId="interval-selection-label"
                                        id="interval"
                                        name="interval"
                                        margin="dense"
                                    >
                                        <MenuItem value={1}>Mensal</MenuItem>
                                        <MenuItem value={2}>Bimestral</MenuItem>
                                        <MenuItem value={3}>
                                            Trimestral
                                        </MenuItem>
                                        <MenuItem value={6}>Semestral</MenuItem>
                                        <MenuItem value={12}>Anual</MenuItem>
                                    </Field>
                                </FormControl>
                            </Grid2>
                        )} */}
                        {/* <Grid2
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 4,
                            }}
                            style={{ position: "relative" }}
                        >
                            <Tooltip
                                style={{
                                    position: "absolute",
                                    right: 18,
                                    top: 11,
                                    zIndex: 99,
                                }}
                                title="Quantidade de parcelas a cobrar. Deixar vazio, para cobrar de forma vitalícia"
                            >
                                <IconButton aria-label="parcelas">
                                    <InfoOutlined />
                                </IconButton>
                            </Tooltip>
                            <Field
                                as={TextField}
                                id="parcelas"
                                label="Parcelas"
                                name="repeats"
                                variant="outlined"
                                className={classes.fullWidth}
                                margin="dense"
                                type="number"
                            />
                        </Grid2> */}
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Field
                                as={TextField}
                                label="Conexões"
                                name="connections"
                                variant="outlined"
                                className={classes.fullWidth}
                                margin="dense"
                                type="number"
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Field
                                as={TextField}
                                label="Filas"
                                name="queues"
                                variant="outlined"
                                className={classes.fullWidth}
                                margin="dense"
                                type="number"
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Tooltip title="Marque esta caixa para criar um plano gratuito para parceiros comerciais. Planos para parceiros comerciais não geram cobranças.">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isCustomPlan}
                                            onChange={(event) => {
                                                setIsCustomPlan(
                                                    event.target.checked,
                                                )
                                            }}
                                            name="isCustomPlan"
                                            color="primary"
                                        />
                                    }
                                    label="Ocultar plano"
                                />
                            </Tooltip>
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <Typography variant="h6">
                                Funcionalidades
                            </Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.dashboard || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "dashboard",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Dashboard</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.kanban || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "kanban",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Kanban</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.forms || false}
                                    onChange={(e) =>
                                        setFieldValue("forms", e.target.checked)
                                    }
                                />
                                <label>Formulários</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.products || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "products",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Produtos</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.leads || false}
                                    onChange={(e) =>
                                        setFieldValue("leads", e.target.checked)
                                    }
                                />
                                <label>Leads</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.tags || false}
                                    onChange={(e) =>
                                        setFieldValue("tags", e.target.checked)
                                    }
                                />
                                <label>Tags</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.prompt || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "prompt",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Prompts</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.campaigns || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "campaigns",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Campanhas</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.quickMessages || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "quickMessages",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Respostas rápidas</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.schedules || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "schedules",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Agendar mensagens</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.queueIntegration || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "queueIntegration",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Integrações</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.audios || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "audios",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Áudios pré gravados</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.automation || false}
                                    onChange={(e) =>
                                        setFieldValue(
                                            "automation",
                                            e.target.checked,
                                        )
                                    }
                                />
                                <label>Automações Redes Sociais</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box display="flex" alignItems="center">
                                <Switch
                                    checked={values.chats || false}
                                    onChange={(e) =>
                                        setFieldValue("chats", e.target.checked)
                                    }
                                />
                                <label>Chat interno</label>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <Grid2
                                justifyContent="flex-end"
                                spacing={1}
                                container
                            >
                                <Grid2 size={{ xs: 4, md: 1 }}>
                                    <ButtonWithSpinner
                                        className={classes.fullWidth}
                                        loading={loading}
                                        onClick={() => onCancel()}
                                        variant="contained"
                                    >
                                        Cancelar
                                    </ButtonWithSpinner>
                                </Grid2>
                                {record.id !== undefined ? (
                                    <Grid2 size={{ xs: 4, md: 1 }}>
                                        <ButtonWithSpinner
                                            className={classes.fullWidth}
                                            loading={loading}
                                            onClick={() => onDelete(record)}
                                            variant="contained"
                                            color="secondary"
                                        >
                                            Excluir
                                        </ButtonWithSpinner>
                                    </Grid2>
                                ) : null}
                                <Grid2 size={{ xs: 4, md: 1 }}>
                                    <ButtonWithSpinner
                                        className={classes.fullWidth}
                                        loading={loading}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Salvar
                                    </ButtonWithSpinner>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Form>
            )}
        </Formik>
    )
}

export function PlansManagerGrid(props) {
    const { records, onSelect, local } = props
    const classes = useStyles()

    return (
        <Paper className={classes.tableContainer}>
            <Table
                className={classes.fullWidth}
                size="small"
                aria-label="a dense table"
            >
                <TableHead>
                    <TableRow>
                        <TableCell align="center" style={{ width: "1%" }}>
                            #
                        </TableCell>
                        <TableCell align="left">ID</TableCell>
                        <TableCell align="left">Nome</TableCell>
                        <TableCell align="center">Valor</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {records?.map((row) => (
                        <TableRow key={row?.id}>
                            <TableCell align="center" style={{ width: "1%" }}>
                                <IconButton
                                    onClick={() => onSelect(row)}
                                    aria-label="delete"
                                >
                                    <EditIcon />
                                </IconButton>
                            </TableCell>
                            <TableCell align="left">
                                {local ? row.id : row?._id || "-"}
                            </TableCell>
                            <TableCell align="left">
                                {row?.name || "-"}
                            </TableCell>
                            <TableCell align="center">
                                {fCurrency(row.value / 100)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    )
}

export default function PlansManager() {
    const classes = useStyles()
    const { list, save, update, remove, local } = usePlans()

    const [mode, setMode] = useState("list") // list | form

    const [localPlans, setLocalPlans] = useState([])

    const [showConfirmDialog, setShowConfirmDialog] = useState(false)
    const [loading, setLoading] = useState(false)
    const [records, setRecords] = useState([])
    const [record, setRecord] = useState({
        name: "",
        users: 0,
        connections: 0,
        queues: 0,
        value: 0,
        interval: 1,

        lytexId: "",

        dashboard: true,
        kanban: true,
        forms: true,
        products: true,
        leads: true,
        tags: true,
        prompt: true,
        quickMessages: true,
        schedules: true,
        queueIntegration: true,
        audios: true,
        automation: true,
        chats: true,
        campaigns: true,
    })

    useEffect(() => {
        async function fetchData() {
            await loadPlans()
        }
        fetchData()
    }, [])

    const loadPlans = async () => {
        setLoading(true)
        try {
            const [data, localPLanData] = await Promise.all([
                await list(),
                await local(),
            ])

            setRecords(data.results)
            setLocalPlans(localPLanData)
        } catch (e) {
            toast.error("Não foi possível carregar a lista de registros")
        }
        setLoading(false)
    }

    const handleSubmit = async (data) => {
        const datanew = {
            id: data.id,
            connections: data.connections,
            name: data.name,
            queues: data.queues,
            users: data.users,
            value: parseFloat(data.value),
            interval: data.interval,
            repeats: data.repeats,
            isCustomPlan: data.isCustomPlan,

            dashboard: data.dashboard,
            kanban: data.kanban,
            forms: data.forms,
            products: data.products,
            leads: data.leads,
            tags: data.tags,
            prompt: data.prompt,
            quickMessages: data.quickMessages,
            schedules: data.schedules,
            queueIntegration: data.queueIntegration,
            audios: data.audios,
            automation: data.automation,
            chats: data.chats,
            campaigns: data.campaigns,
        }
        setLoading(true)
        try {
            if (data.id !== undefined) {
                await update(datanew)
            } else {
                await save(datanew)
            }
            await loadPlans()
            handleCancel()
            toast.success("Operação realizada com sucesso!")
            setMode("list")
        } catch (e) {
            toast.error(
                "Não foi possível realizar a operação. Verifique se já existe uma plano com o mesmo nome ou se os campos foram preenchidos corretamente",
            )
        }
        setLoading(false)
    }

    const handleDelete = async () => {
        setLoading(true)
        try {
            await remove(record.id)
            await loadPlans()
            handleCancel()
            toast.success("Operação realizada com sucesso!")
            setMode("list")
        } catch (e) {
            toast.error("Não foi possível realizar a operação")
        }
        setLoading(false)
    }

    const handleOpenDeleteDialog = () => {
        setShowConfirmDialog(true)
    }

    const handleCancel = () => {
        setRecord({
            name: "",
            users: 0,
            connections: 0,
            queues: 0,
            value: 0,

            dashboard: true,
            kanban: true,
            forms: true,
            products: true,
            leads: true,
            tags: true,
            prompt: true,
            quickMessages: true,
            schedules: true,
            queueIntegration: true,
            audios: true,
            automation: true,
            chats: true,
            campaigns: true,
        })

        setMode("list")
    }

    const handleSelect = async (item, local) => {
        setMode("form")

        try {
            let data

            if (local) {
                const { data: dataRes } = await api.get(
                    `/plans/local/${item.id}`,
                )
                data = dataRes
            } else {
                const { data: dataRes } = await api.get(`/plans/${item._id}`)
                data = dataRes
            }

            setRecord({
                id: data.id,
                name: data.name || "",
                users: data.users || 0,
                connections: data.connections || 0,
                queues: data.queues || 0,
                interval: data.interval,
                value: data.value,
                lytexId: data.lytexId,
                isCustomPlan: data.isCustomPlan,
                dashboard: data.dashboard,
                kanban: data.kanban,
                forms: data.forms,
                products: data.products,
                leads: data.leads,
                tags: data.tags,
                prompt: data.prompt,
                quickMessages: data["quick-messages"],
                schedules: data.schedules,
                queueIntegration: data.queueIntegration,
                audios: data.audios,
                automation: data.automation,
                chats: data.chats,
                campaigns: data.campaigns,
            })
        } catch (error) {
            toast.error("Erro ao buscar plano")
        }
    }

    return (
        <Paper className={classes.mainPaper} elevation={0}>
            <Grid2 spacing={2} container>
                {mode === "form" && (
                    <Grid2
                        size={{
                            xs: 12,
                        }}
                    >
                        <PlanManagerForm
                            initialValue={record}
                            onDelete={handleOpenDeleteDialog}
                            onSubmit={handleSubmit}
                            onCancel={handleCancel}
                            loading={loading}
                        />
                    </Grid2>
                )}
                {mode === "list" && (
                    <Grid2
                        size={{
                            xs: 12,
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{ mb: 2 }}
                            onClick={() => setMode("form")}
                        >
                            Novo plano
                        </Button>

                        <Typography>Planos Lytex</Typography>
                        <PlansManagerGrid
                            records={records}
                            onSelect={handleSelect}
                        />

                        <Typography sx={{ mt: 4 }}>Planos grátis</Typography>
                        <PlansManagerGrid
                            records={localPlans}
                            onSelect={(item) => handleSelect(item, true)}
                            local
                        />
                    </Grid2>
                )}
            </Grid2>
            <ConfirmationModal
                title="Exclusão de Registro"
                open={showConfirmDialog}
                onClose={() => setShowConfirmDialog(false)}
                onConfirm={() => handleDelete()}
            >
                Deseja realmente excluir esse registro?
            </ConfirmationModal>
        </Paper>
    )
}
